import { Modal } from 'bootstrap';
import { onReady } from '../lib/on-ready.js';
import { onActivateKey, activateClick } from '../lib/keyboard.js';

function initModals() {
    document.querySelectorAll('.modal-component').forEach((modal) => {
        const openModal = modal.querySelector('.open-modal');
        if (openModal) {
            const instance = new Modal(openModal);
            instance.show();
        }
    });

    document.querySelectorAll('.modalCta, .two-col-video-modal-btn').forEach((trigger) => {
        onActivateKey(trigger, () => activateClick(trigger));
    });
}

onReady(initModals);
